import './manual-pull-log-header.component.scss';
import {LogItem} from "../../model/LogItem";
import {IScope, ITimeoutService} from "angular";
import {ReportLog} from "../../model/ReportLog";
import {ImportStatusToIconConverter} from "../../services/ImportStatusToIconConverter";
import {ImportStatus} from "../../model/ImportStatus";
import {ImportSource} from "../../model/ImportSource";
import {CustomerImportDialogWrapper} from "../import-contacts/wrapper/impl/customer/customer-import-dialog-wrapper";
import {LeadImportDialogWrapper} from "../import-contacts/wrapper/impl/lead/lead-import-dialog-wrapper";
import {PartnerImportDialogWrapper} from "../import-contacts/wrapper/impl/partner/partner-import-dialog-wrapper";

interface IconParam {
    show: boolean;
    url: string;
    description?: string;
}

interface DialogParam {
    show: boolean;
}

export class ManualPullLogHeaderComponent {

    static instance = {
        controller: [
            '$scope',
            '$timeout',
            '$mdDialog',
            ManualPullLogHeaderComponent
        ],
        template: require('./manual-pull-log-header.component.html'),
        bindings: {
            title: '<',
            started: '<',
            logItem: '=',
        }, scope: {
            iconParam: '=',
            dialogParam: '='
        },
    };


    private logItem: LogItem;
    private title: string;
    private started: Date;
    private iconParam: IconParam;
    private dialogParam: DialogParam;

    constructor(private $scope: IScope,
                private $timeout: ITimeoutService,
                private $mdDialog: angular.material.IDialogService) {
    }

    $onInit() {
        this.title = this.initTitle();
        this.started = this.initStartedDate();
        this.iconParam = this.initIconParam();
        this.dialogParam = this.initDialogParam();
        this.logItem.logSubject.asObservable().subscribe(this.handleLogUpdate)
    }

    private handleLogUpdate = (log: ReportLog) => {
        this.$timeout(() => {
            this.logItem.log = log;
            this.started = log.startedAt;
            this.iconParam.show = true;
            this.iconParam.url = this.getIconUrl(log.status);
            this.iconParam.description = this.getIconDescription(log.status);
            this.dialogParam.show = log.status === ImportStatus.SUCCEEDED;
            this.$scope.$apply();
        });
    };

    private initTitle() {

        if (this.logItem.log.title) {
            return this.logItem.log.title;
        } else {
            return null;
        }
    }

    private initStartedDate() {
        return this.logItem.log.startedAt;
    }

    private initIconParam(): IconParam {

        return {
            show: false,
            url: ""
        };

    }


    private initDialogParam(): DialogParam {
        return {
            show: false
        }
    }

    private getIconUrl(status: ImportStatus) {
        return ImportStatusToIconConverter.getIconPath(status);
    }

    private getIconDescription(status: ImportStatus) {
        return ImportStatusToIconConverter.getUiDescription(status);
    }

    showContacts = () => {
        let log = this.logItem.log;
        switch (log.source) {
            case ImportSource.CSV_LEADS:
                this.$mdDialog.show(LeadImportDialogWrapper.instance(log));
                break;
            case ImportSource.CSV_PARTNERS:
                this.$mdDialog.show(PartnerImportDialogWrapper.instance(log));
                break;
            default:
                this.$mdDialog.show(CustomerImportDialogWrapper.instance(log));
        }
    };
}